import { WidgetType } from "@codemirror/view";

export class BraceWidget extends WidgetType {
    constructor(content = "") {
        super();
        this.content = content;
    }

    toDOM() {
        const element = document.createElement("span");
        element.classList.add("ol-cm-brace");
        element.textContent = this.content;
        return element;
    }

    ignoreEvent(event) {
        return event.type !== "mousedown" && event.type !== "mouseup";
    }

    eq(widget) {
        return widget.content === this.content;
    }

    updateDOM(element) {
        element.textContent = this.content;
        return true;
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }
}
